import React, { useState, useEffect } from 'react'

import { NotificationToast } from '../tools/Toast'

import { useDispatch } from 'react-redux'

import { deleteComment, getComments, updateComment } from '../../../redux/actions'

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'

import Grid from '@material-ui/core/Grid'
import Avatar from '@material-ui/core/Avatar'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'

import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'

import MoreVertIcon from '@material-ui/icons/MoreVert'
import DoneIcon from '@material-ui/icons/Done'
// import ReplayIcon from '@material-ui/icons/Replay'
import CloseIcon from '@material-ui/icons/Close'

import moment from 'moment'

import { handleTextPrepper } from '../../../utils'

export const CommentList = ({
  classes, comment, violationID, place, onEdit, signedSupervisor,
  onEditing, onStopEditing, editingComment, commentText, setCommentText,
  currentView, currentCapture
}) => {
  const dispatch = useDispatch()

  const [anchorEl, setAnchorEl] = useState(null)
  const [editing, setEditing] = useState(false)
  const [commentContent, setCommentContent] = useState(comment.comment)

  const { firstName = '', lastName = '', avatarPath = '' } = comment
  const authorFullName = firstName && lastName ? `${firstName} ${lastName}` : 'User Unavailable'
  const avatarSrc = avatarPath ? `${avatarPath}?${new Date().getTime()}` : ''
  const avatarDetails = !avatarPath && firstName && lastName ? `${firstName?.substring(0, 1)} ${lastName?.substring(0, 1)}` : ''

  useEffect(() => {
    if (comment) {
      setCommentContent(comment.comment)
    }
  }, [comment])

  useEffect(() => {
    if (currentView !== currentCapture) {
      setEditing(false)
    }
  }, [currentCapture, currentView])

  const handleClick = (e) => {
    setAnchorEl(e.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const date = new Date(comment.timestamp)
  const actualDate = `${(date.getMonth() + 1)}/${date.getDate()}/${date.getFullYear()}`
  const actualTime = moment(date).format('LTS')

  const handleDelete = () => {
    handleClose()
    dispatch(deleteComment(violationID, comment.commentID, fireDeleteSuccess, fireDeleteFailure))
  }

  const fireDeleteSuccess = () => {
    NotificationToast(false, 'Successfully deleted comment!')
    dispatch(getComments([violationID]))
  }

  const fireDeleteFailure = () => {
    NotificationToast(true, 'Failed to delete comment!')
  }

  const handleSave = () => {
    onEdit(place, commentContent)
    dispatch(updateComment(violationID, comment.commentID, handleTextPrepper(commentContent), fireUpdateSuccess, fireUpdateFailure))
  }

  const fireUpdateSuccess = () => {
    NotificationToast(false, 'Successfully updated comment!')
    setEditing(false)
    onStopEditing()
  }

  const fireUpdateFailure = () => {
    NotificationToast(true, 'Failed to update comment!')
  }

  const handleIgnore = () => {
    setEditing(false)
    onStopEditing()
    setCommentContent(comment.comment)
  }

  const handleKeyPress = (e) => {
    if (e.key) {
      if (e.key.toUpperCase() === 'ENTER') {
        handleSave()
      }
    }
  }

  const handleEditing = () => {
    handleClose()
    setEditing(true)
    onEditing()
  }

  return (
    <>
      <ListItem>
        <ListItemAvatar>
          <Tooltip title={authorFullName} placement='top'>
            <Avatar className={classes.commentAvatar} src={avatarSrc}>
              {avatarDetails}
            </Avatar>
          </Tooltip>
        </ListItemAvatar>
        <ListItemText
          primary={
            <Grid container>
              <Grid item xs={9} container direction='row' spacing={2}>
                <Grid item xs={8} container alignContent='center'>
                  <Typography variant='body1' className='font-weight-bold text-wrap w-100'>{authorFullName}</Typography>
                </Grid>
                <Grid item container xs={4} alignContent='center'>
                  <Typography variant='caption' className='text-muted'>
                    {actualTime}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={3} container direction='row' justify='flex-end' alignContent='center'>
                <Typography variant='caption' className='text-muted'>
                  {actualDate}
                </Typography>
              </Grid>
            </Grid>
          }
          secondary={
            <Grid container>
              <Grid container direction='row'>
                {editing ? (
                  <Grid container justify='space-between' spacing={2}>
                    <Grid item xs={8} container alignContent='center'>
                      <TextField
                        id={`comment-${comment.commentID}`}
                        value={commentContent}
                        onChange={(e) => setCommentContent(e.target.value)}
                        label=''
                        className='w-100'
                        onKeyDown={handleKeyPress}
                      />
                    </Grid>
                    <Grid item xs={4} container justify='flex-start' spacing={2}>
                      <Grid item>
                        <Tooltip placement='top' title='Save Changes' enterDelay={500}>
                          <IconButton
                            onClick={handleSave}
                            className={classes.saveFab}
                          >
                            <DoneIcon />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                      <Grid item>
                        <Tooltip placement='top' title='Discard Changes' enterDelay={500}>
                          <IconButton
                            onClick={handleIgnore}
                            className={classes.discardFab}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Typography component='span' variant='body2' className='text-wrap w-100'>{comment.comment}</Typography>
                )}
              </Grid>
            </Grid>
          }
          className='text-dark'
          disableTypography
        />
        {comment.supervisorID === signedSupervisor.supervisorID ? (
          <ListItemSecondaryAction>
            <IconButton edge='end' onClick={handleClick}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              keepMounted
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={handleEditing}>Edit</MenuItem>
              <MenuItem onClick={handleDelete}>Delete</MenuItem>
            </Menu>
          </ListItemSecondaryAction>
        ) : (
          <></>
        )}
      </ListItem>
      <Divider variant='inset' component='li' />
    </>
  )
}

export default CommentList
